import {
    RESET_REPORT_STATE,
    RESET_REPORT_ACTION_STATE,
    GET_SALES_PERFORMANCE,
    GET_SALES_PERFORMANCE_SUCCESS,
    GET_SALES_PERFORMANCE_FAIL,
    GET_DOCTOR_PERFORMANCE,
    GET_DOCTOR_PERFORMANCE_SUCCESS,
    GET_DOCTOR_PERFORMANCE_FAIL,
    GET_DOCTOR_REPORT_DETAILS,
    GET_DOCTOR_REPORT_DETAILS_SUCCESS,
    GET_DOCTOR_REPORT_DETAILS_FAIL,
    GET_DOCTOR_PAYMENT_REPORT_DETAILS,
    GET_DOCTOR_PAYMENT_REPORT_DETAILS_SUCCESS,
    GET_DOCTOR_PAYMENT_REPORT_DETAILS_FAIL,
    GET_PAY_COMMISSION_REPORT,
    GET_PAY_COMMISSION_REPORT_SUCCESS,
    GET_PAY_COMMISSION_REPORT_FAIL,
    EXPORT_DOCTOR_PERFORMANCE,
    EXPORT_DOCTOR_PERFORMANCE_SUCCESS,
    EXPORT_DOCTOR_PERFORMANCE_FAIL,
    EXPORT_DOCTOR_SALES,
    EXPORT_DOCTOR_SALES_SUCCESS,
    EXPORT_DOCTOR_SALES_FAIL,
} from "./actionTypes";

export const getSalesPerformance = (payload) => ({
    type: GET_SALES_PERFORMANCE,
    payload: payload
});

export const getSalesPerformanceSuccess = categories => ({
    type: GET_SALES_PERFORMANCE_SUCCESS,
    payload: categories,
});

export const getSalesPerformanceFail = error => ({
    type: GET_SALES_PERFORMANCE_FAIL,
    payload: error,
});

export const getDoctorPerformance = doctorId => ({
    type: GET_DOCTOR_PERFORMANCE,
    payload: doctorId,
});

export const getDoctorPerformanceSuccess = doctor => ({
    type: GET_DOCTOR_PERFORMANCE_SUCCESS,
    payload: doctor,
});

export const getDoctorPerformanceFail = error => ({
    type: GET_DOCTOR_PERFORMANCE_FAIL,
    payload: error,
});

export const getDoctorDetailsReport = doctor => ({
    type: GET_DOCTOR_REPORT_DETAILS,
    payload: doctor,
});

export const getDoctorDetailsReportSuccess = doctor => ({
    type: GET_DOCTOR_REPORT_DETAILS_SUCCESS,
    payload: doctor,
});

export const getDoctorDetailsReportFail = error => ({
    type: GET_DOCTOR_REPORT_DETAILS_FAIL,
    payload: error,
});

export const getDoctorPaymentReport = admin => ({
    type: GET_DOCTOR_PAYMENT_REPORT_DETAILS,
    payload: admin,
});

export const getDoctorPaymentReportSuccess = admin => ({
    type: GET_DOCTOR_PAYMENT_REPORT_DETAILS_SUCCESS,
    payload: admin,
});

export const getDoctorPaymentReportFail = error => ({
    type: GET_DOCTOR_PAYMENT_REPORT_DETAILS_FAIL,
    payload: error,
});

export const getPayCommissionReport = admin => ({
    type: GET_PAY_COMMISSION_REPORT,
    payload: admin,
});

export const getPayCommissionReportSuccess = admin => ({
    type: GET_PAY_COMMISSION_REPORT_SUCCESS,
    payload: admin,
});

export const getPayCommissionReportFail = error => ({
    type: GET_PAY_COMMISSION_REPORT_FAIL,
    payload: error,
});

export const exportDoctorPerformance = admin => ({
    type: EXPORT_DOCTOR_PERFORMANCE,
    payload: admin,
});

export const exportDoctorPerformanceSuccess = admin => ({
    type: EXPORT_DOCTOR_PERFORMANCE_SUCCESS,
    payload: admin,
});

export const exportDoctorPerformanceFail = error => ({
    type: EXPORT_DOCTOR_PERFORMANCE_FAIL,
    payload: error,
});

export const exportDoctorSales = admin => ({
    type: EXPORT_DOCTOR_SALES,
    payload: admin,
});

export const exportDoctorSalesSuccess = admin => ({
    type: EXPORT_DOCTOR_SALES_SUCCESS,
    payload: admin,
});

export const exportDoctorSalesFail = error => ({
    type: EXPORT_DOCTOR_SALES_FAIL,
    payload: error,
});

//reset
export const resetReportState = () => {
    return {
        type: RESET_REPORT_STATE,
    }
}
//reset attachment
export const resetReportActionState = () => {
    return {
        type: RESET_REPORT_ACTION_STATE,
    }
}

